import React from 'react';
import { Box, LinearProgress } from '@mui/material';

import { LogsSyncProgress } from '../../interfaces';

interface Props {
    progress: LogsSyncProgress | null;
}

export const SyncProgressBar = ({ progress }: Props) => {
    if (!progress) {
        return null;
    }

    const { phase, processedFilesCount, expectedTotalFiles, failedFilesCount } = progress;

    const totalFiles = expectedTotalFiles ?? 0;
    const hasTotal = totalFiles > 0;
    const percent = hasTotal ? Math.min(100, Math.round((processedFilesCount / totalFiles) * 100)) : null;

    const isScanning = phase === 'enumerating' || !hasTotal;

    const label = () => {
        if (phase === 'finished') {
            return `Finished — 100% (${processedFilesCount} / ${totalFiles || processedFilesCount})`;
        }

        if (isScanning) {
            return 'Scanning device…';
        }

        return `Uploading… ${percent}% (${processedFilesCount} / ${totalFiles})`;
    };

    return (
        <Box my={2}>
            <Box display="flex" gap={2} alignItems="baseline" mb={0.5} flexWrap="wrap">
                <strong>{label()}</strong>
                {failedFilesCount > 0 && <Box color="error.main">Failed: {failedFilesCount}</Box>}
            </Box>
            <LinearProgress
                variant={isScanning ? 'indeterminate' : 'determinate'}
                value={isScanning ? undefined : percent ?? 0}
                color={failedFilesCount > 0 ? 'warning' : 'primary'}
            />
        </Box>
    );
};
